{
  "welcome": {
    "title": "Mirë se erdhe, {{name}}",
    "title_noName": "Mirë se erdhe në Rhemn",
    "body": "Çdo gjë që ndriçon të tregon çfarë bën. Eksploro në çdo renditje, kur të duash.",
    "start": "Fillo eksplorimin",
    "later": "Jo tani"
  },
  "card": {
    "tryIt": "Provoje",
    "takeALook": "Hidh një sy",
    "pro": "Pjesë e Rhemn Pro",
    "close_aria": "Mbyll"
  },
  "pill": {
    "progress": "{{count}} nga {{total}} të eksploruara",
    "progress_short": "{{count}} nga {{total}}",
    "done": "U krye",
    "done_aria": "Përfundo eksplorimin",
    "complete": "Të gjitha u eksploruan"
  },
  "sr": {
    "started": "Modaliteti i eksplorimit është aktiv. Butonat tregojnë çfarë bëjnë para se të veprojnë.",
    "hint": "Modaliteti i eksplorimit. Tregon së pari çfarë bën ky element.",
    "ended": "Modaliteti i eksplorimit është joaktiv."
  },
  "settings": {
    "row": "Si funksionon Rhemn",
    "row_sub": "Një vështrim i shkurtër për çdo pjesë",
    "row_aria": "Si funksionon Rhemn: eksploro sërish aplikacionin",
    "helpCaption": "Ndihmë"
  },
  "steps": {
    "intention": {
      "title": "Nijeti i sotëm",
      "body": "Shkruaj gjënë më të rëndësishme të ditës dhe shënoje kur ta kesh kryer."
    },
    "now": {
      "title": "Dita jote, sipas namazeve",
      "body": "Rhemn e ndan ditën tënde në çdo namaz. Këtu sheh kohën që mbetet deri te namazi i radhës dhe çfarë ke planifikuar për të."
    },
    "verse": {
      "title": "Njohuri për ajetin",
      "body": "Bëj një pyetje për ajetin e sotëm, lexo një tefsir të shkurtër dhe gjej ajete me të njëjtën temë."
    },
    "qibla": {
      "title": "Kibla",
      "body_chrome": "Drejtimi i Qabes nga vendi ku ndodhesh, në gradë nga veriu.",
      "body_ios": "Tregon drejt Qabes nga vendi ku ndodhesh. Aktivizo busullën në kohë reale dhe ajo të ndjek ndërsa kthehesh."
    },
    "prayer": {
      "title": "Oraret e namazit",
      "body_chrome": "Pesë kohët e namazit për sot, sipas vendit ku ndodhesh. Zgjidh metodën e llogaritjes që ndjek xhamia jote.",
      "body_ios": "Namazi i radhës me një shikim. Hape për të parë pesë kohët dhe një kujtues për secilën."
    },
    "tasks": {
      "title": "Detyrat",
      "body": "Mbaji detyrat në lista dhe jepi secilës një vend mes namazeve."
    },
    "notes": {
      "title": "Shënimet",
      "body_chrome": "Shkruaj, ose thjesht fol. Rhemn transkripton shënimet e tua zanore dhe takimet, pastaj i përmbledh.",
      "body_ios": "Shkruaj, ose thjesht fol. Rhemn e kthen atë që thua në shënime të qarta e të përmbledhura."
    },
    "profile": {
      "title_chrome": "Profili yt",
      "body_chrome": "Llogaria dhe cilësimet e privatësisë. Kthehu këtu për ta eksploruar sërish Rhemn.",
      "title_ios": "Më shumë",
      "body_ios": "Ajetet e ruajtura, Kibla dhe cilësimet e llogarisë. Nga këtu mund ta eksplorosh sërish Rhemn."
    }
  }
}
